// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CVNZb","importantInfo":"styles_importantInfo__2w-ze"};